import { ApiContext } from './ApiContext';
import { useContext } from 'react';

export const useApi = () => {
  return useContext(ApiContext);
};
